export default "__VITE_ASSET__D1AMLhRz__"